import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export const deliveryReport = "/delivery-report";

export enum DeliveryReportSortField {
  dnNo = "dnNo",
  poNo = "poNo",
  soNo = "soNo",
  itemNo = "itemNo",
  materialDescription = "materialDescription",
  quantity = "deliveryQty",
  shipTo = "shipTo",
  giDate = "cutOffDate",
  carRegistrationNo = "truckNo",
  departurePlacePositions = "originName",
  estimateDateTime = "planDelivery",
  transportStatus = "lmsStatus",
  matNumber = "matNumber",
  deliveryWeight = "deliveryWeight",
  // admin
  soldToCodeName = "soldToCode",
  shipToName = "destinationName",
  billNo = "billNo"
}

export type DeliveryReport = Sort<DeliveryReportSortField>;
export type DeliveryReportUrlQueryParams = Pagination & DeliveryReport;

export const deliveryReportUrl = (params?: DeliveryReportUrlQueryParams) =>
  deliveryReport + "?" + stringifyQs(params);
